import { TICKET } from "./action";

export function reconciliationReducer(state = {}, action) {
  switch (action.type) {
    case TICKET.getTicketList.success:
      return Object.assign({}, state, {
        TicketList: action.data
      });
    case TICKET.getTicketDetails.success:
      return Object.assign({}, state, {
        TicketDetails: action.data
      });

    case TICKET.setReconcileSuccess.success:
      return Object.assign({}, state, {
        TicketDetails: {},
        setReconcileSuccess: true,
        postTicketDetails: action.data
      });
    case TICKET.upDateTicketDetails.success:
      return Object.assign({}, state, {
        upDateTicketDetails: action.data
      });
    case TICKET.getReconciledTicketDetails.success:
      return Object.assign({}, state, {
        ReconciledData: action.data
      });
    case TICKET.emptyStateOnReconciliation.success:
      return Object.assign({}, state, {
        TicketDetails: {},
        ReconciledData: {}
      });
    case TICKET.deleteReconciledTicketDetails.success:
      return Object.assign({}, state, {
        ReconciledData: action.data
      });
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/modules/reconciliation/reducer.js